import { useDRPContext } from "../context";
import { DateRangePickerViews } from "../types";
import { DRPDay } from "../views/day";
import { DRDPHeader } from "../views/day/header";
import { DRPMonth } from "../views/month";
import { DRMPHeader } from "../views/month/header";
import { DRPYear } from "../views/year";
import { DRYPHeader } from "../views/year/header";
import { DRPChips } from "./chips";
import { DRPRadio } from "./radio";
import { DRPPopoverContainer, classes } from "./styles";

export const DRPPopover = () => {
  const { open, handleClose, anchorEl, selectedView } = useDRPContext();

  return (
    <DRPPopoverContainer
      className={classes.root}
      open={open}
      onClose={handleClose}
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
    >
      {selectedView === DateRangePickerViews.DAY && <DRDPHeader />}
      {selectedView === DateRangePickerViews.MONTH && <DRMPHeader />}
      {selectedView === DateRangePickerViews.YEAR && <DRYPHeader />}
      <DRPRadio />
      {selectedView === DateRangePickerViews.DAY && (
        <>
          <DRPDay />
          <DRPChips />
        </>
      )}
      {selectedView === DateRangePickerViews.MONTH && <DRPMonth />}
      {selectedView === DateRangePickerViews.YEAR && <DRPYear />}
    </DRPPopoverContainer>
  );
};
